/// <summary>
/// Auth : 정지효
/// Date : 2023/05/19
/// Desc : AI 시스템 관리자페이지
/// </summary>

import React, { useState } from 'react';
import { useNavigate } from 'react-router';
import {
    Column,
    DataGrid,
    Editing,
    Pager,
    Paging,
    Selection,
    Toolbar,
    Item,
    Export,
} from 'devextreme-react/data-grid';
import { Button } from 'devextreme-react/button';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';
import { exportDataGrid } from 'devextreme/excel_exporter';
import config from './Config.js';



const renderImageLink = (e) => {
        return (
            <a style={{color: "blue"}} href={`result/${e.data.jobNo}`} target="_blank" rel="noopener noreferrer">
                {e.data.recogRate.toFixed(0)+"%"}
            </a>
        );
    };

const onExporting = (e) => {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Main sheet');

    exportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true,
    }).then(() => {
        // Customize the cell formatting for the "recogRate" column
        const recogRateColumn = worksheet.getColumn('H');
        recogRateColumn.eachCell((cell, rowNumber) => {
            if (rowNumber > 1 && cell.value !== undefined) {
                cell.value = parseFloat(cell.value) / 100;
                cell.numFmt = '0%';
            }
        });

        workbook.xlsx.writeBuffer().then((buffer) => {
            saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'AI해석데이터.xlsx');
        });
    });
    e.cancel = true;
}

const renderRowNumberColumn = (cellData) => {
    const rowNumber = cellData.row.rowIndex + 1;
    return rowNumber
}

export default function RecogResultDatagrid({ dataSource, handleSearch }) {

    const navigate = useNavigate();
    const [selectedItemKeys, setSelectedItemKeys] = useState([]);
    const deleteRecords = async () => {
        const _ = await Promise.all(selectedItemKeys.map((key) => {
            //console.log(key.jobNo);
            fetch(`${config.apiUrl}/adminpage/masterpage/${key.jobNo}`, { method: 'DELETE', credentials: 'include' })
            .then((response) => {
                if (response.status === 401) {
                  navigate('/login');
                }
              });
        }));
        setSelectedItemKeys([]);
        handleSearch(); 
    };

    const selectionChanged = (data) => {
        //console.log("selected", data);
        setSelectedItemKeys(data.selectedRowKeys);
    };

    return (
        <DataGrid
            dataSource={dataSource}
            onSelectionChanged={selectionChanged}
            onExporting={onExporting}
        >
            <Selection 
                mode="multiple"
                showCheckBoxesMode="onClick"
             />
            <Paging defaultPageSize={25} />
            <Pager
                displayMode='full'
            />
            <Editing
                mode="cell"
            />
            <Column dataField={dataSource} caption="NO" alignment="center" width="65px" cellRender={renderRowNumberColumn}/>
            <Column dataField="jobNo" caption="JOBNO" alignment="center" width="85px" sortOrder="desc"/>
            <Column dataField="regDate" caption="해석등록일" alignment="center" width="7%"/>
            <Column dataField="prodName" caption="제품명" alignment="center" />
            <Column dataField="compName" caption="고객명" alignment="center" />
            <Column dataField="firmName" caption="거래처명" alignment="center" />
            <Column dataField="siteName" caption="현장명" alignment="center" />
            <Column dataField="recogRate" caption="인식률" alignment="center" width="100px" cellRender={renderImageLink}/>
            <Column dataField="enterer" caption="변환요청자" alignment="center" />
            <Column dataField="enterDay" caption="변환요청일시" alignment="center" />
            <Column dataField="enterIP" caption="변환요청IP" alignment="center" />
            <Toolbar>
                <Item>
                    <Button
                        onClick={handleSearch}
                        icon="search"
                        hint="조회"
                    />
                </Item>
                <Item location="after">
                    <Button
                        onClick={deleteRecords}
                        icon="trash"
                        hint="삭제" 
                    />
                </Item>
                <Item name="exportButton" />
            </Toolbar>
            <Export enabled={true} />
        </DataGrid>
    );

    
}